import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-expect-error fix later
import { getLegacyStore } from '@beef/legacy-beeline-store';
import { loadingReducer } from "../components/Loader";
import { fttbAvailableSchedule, fttbCatalogData, fttbConnectionState, fttbSpecialTariffData, fttbTariffPage, fttbTvChannelsData, fttbTvConsoles, fttbWifiRouters } from "./reducers";
// import { mapsReducer } from 'pages/Maps/store/reducer';
import { addResizeEventListener } from "./resizeListener";
import { setReCaptchaKey, setUser } from "./reducers/common";
var defaultState = {
  fttbWifiRouters: {},
  fttbSelectedTvConsoles: {}
};
var store = getLegacyStore();
var SET_DEFAULT_STATE = 'set default state';

// @ts-expect-error fix later
store.addReducer(function (state, action) {
  return action.type === SET_DEFAULT_STATE ? _objectSpread(_objectSpread({}, state), defaultState) : state;
});
store.dispatch({
  type: SET_DEFAULT_STATE
});

// ------------------------
store.addReducer(loadingReducer);
// ------------------------

store.addReducer(setReCaptchaKey);
store.addReducer(fttbConnectionState);
// store.addReducer(mapsReducer);
store.addReducer(fttbCatalogData);
store.addReducer(fttbSpecialTariffData);
store.addReducer(fttbTvChannelsData);
store.addReducer(fttbAvailableSchedule);
store.addReducer(fttbTariffPage);
store.addReducer(fttbWifiRouters);
store.addReducer(fttbTvConsoles);
store.addReducer(setUser);
addResizeEventListener(store);
export { store };